export const formatCurrency = (amount) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '—';
  return `₹${value.toLocaleString('en-IN')}`;
};

export const getInitial = (value, fallback = 'A') => (value || fallback).charAt(0).toUpperCase();

export const statusBadgeClass = (status) => {
  if (status === 'sold') return 'bg-success-subtle text-success border border-success-subtle';
  if (status === 'unsold') return 'bg-danger-subtle text-danger border border-danger-subtle';
  if (status === 'current') return 'bg-warning-subtle text-warning-emphasis border border-warning-subtle';
  return 'bg-secondary-subtle text-secondary border border-secondary-subtle';
};

export const getStatusLabel = (status) => {
  const labels = {
    not_started: 'Not Started',
    running: 'Running',
    paused: 'Paused',
    completed: 'Completed',
    available: 'Waiting',
    current: 'Current',
    sold: 'Sold',
    unsold: 'Unsold',
  };
  return labels[String(status || '').toLowerCase()] || 'Not Started';
};

export const getAuctionLifecycleNotice = (status) => {
  if (status === 'not_started') return { tone: 'warning', text: 'Live auction has not started yet.' };
  if (status === 'paused') return { tone: 'warning', text: 'Auction is temporarily paused.' };
  if (status === 'completed') return { tone: 'info', text: 'Auction completed.' };
  return null;
};
